import { objectToQueryString } from 'services/RequestService/helpers';
import snakeCase from 'lodash/snakeCase';

export const SIGN_IN_PATH = '/users/sign_in';
export const OUR_MENU_PATH = '/our-menu';

// COOKBOOK

export const COOKBOOK_PATH = '/account/cookbook';
export const COOKBOOK_SHOPPING_LIST_PATH = `${COOKBOOK_PATH}/shopping_list`;

export const cookbookMealDetailsPath = mealId => `${COOKBOOK_PATH}?mealId=${mealId}`;

// PANTRY

export const PANTRY_ROOT_PATH = '/pantry';
export const PANTRY_CART_PATH = '/pantry/cart';
export const PANTRY_CHECKOUT_PATH = '/pantry/checkout';
export const PANTRY_ORDER_PATH = '/pantry/order/:id';
export const PANTRY_PRODUCT_PATH = '/pantry/:productId';

export const productPath = id => `${PANTRY_ROOT_PATH}/${id}`;

// DASHBOARD

const DASHBOARD_ROOT_PATH = '/account/calendar';

export const ROOT_PATH_NAME = 'ROOT_PATH';
export const MENU_PATH_NAME = 'MENU_PATH';
export const SUMMARY_PATH_NAME = 'SUMMARY_PATH';
export const MEAL_DETAILS_PATH_NAME = 'MEAL_DETAILS_PATH';

export const dashboardRootPath = (params = null) =>
  `${DASHBOARD_ROOT_PATH}${params ? `?${objectToQueryString(params)}` : ''}`;

export const dashboardMenuPath = (menuSlug, params = null) =>
  `${DASHBOARD_ROOT_PATH}/${menuSlug}${params ? `?${objectToQueryString(params)}` : ''}`;

export const dashboardSummaryPath = menuSlug => `${DASHBOARD_ROOT_PATH}/${menuSlug}/summary`;

// Path Matching Helpers
export const isDashboardPath = (pathname, params) => pathname === dashboardRootPath(params);

export const isMenuPath = (pathname, menuSlug, params) =>
  pathname === dashboardMenuPath(menuSlug, params);

export const isSummaryPath = (pathname, menuSlug) => pathname === dashboardSummaryPath(menuSlug);

export const isMealDetailsPath = (pathname, { search, menuSlug, mealId, title }) => {
  const fullPath = `${pathname}${search ? search : ''}`;
  return (
    fullPath === dashboardRootPath({ mealId, menuSlug, title }) ||
    fullPath === dashboardMenuPath(menuSlug, { mealId, title })
  );
};

// ACCOUNT

const ACCOUNT_SETTINGS_PATH = '/account/settings';
export const ACCOUNT_ORDERS_PATH = '/account/order-history';
export const ACCOUNT_ORDERS_SUMMARY_PATH = '/account/order-history/:menuId';
export const ACCOUNT_SETTINGS_PAUSE_REASONS_PATH = `${ACCOUNT_SETTINGS_PATH}/pause-reasons`;
export const ACCOUNT_SETTINGS_PAUSES_PATH = `${ACCOUNT_SETTINGS_PATH}/pause`;
export const ACCOUNT_EDIT_PATH = `${ACCOUNT_SETTINGS_PATH}/edit`;
export const ACCOUNT_SUBSCRIPTION_PATH = `${ACCOUNT_SETTINGS_PATH}/subscriptions`;
export const ACCOUNT_REACTIVATIONS_PATH = `${ACCOUNT_SETTINGS_PATH}/reactive`;
export const ACCOUNT_PREFERENCES_PATH = `${ACCOUNT_SETTINGS_PATH}/taste-profile`;
export const ACCOUNT_PAYMENT_PATH = `${ACCOUNT_SETTINGS_PATH}/billing`;
export const ACCOUNT_SCHEDULE_RESTART = '/account/pause/scheduled-restart/new';
export const ACCOUNT_NOTIFICATIONS_PATH = `${ACCOUNT_SETTINGS_PATH}/notifications`;
export const ACCOUNT_CCPA_REQUEST_PATH = `${ACCOUNT_SETTINGS_PATH}/ccpa-request`;
export const FAQ = '/faq';
export const SUPPORT_REQUEST = '/support-request';

export const railsPauseDeflectorRoute = reason =>
  `/account/pause/reason/new?reason=${snakeCase(reason)}`;

export const pauseSuccessPath = frequencySubscriptionChangeId =>
  `/account/pause/reason/${frequencySubscriptionChangeId}`;

// RECIPE TESTING SOCIETY

const RECIPE_TESTING_SOCIETY_PATH = '/account/recipe-testing-society';

export const dashboardRecipeTestingSocietyPath = (params = null) =>
  `${RECIPE_TESTING_SOCIETY_PATH}${params ? `?${objectToQueryString(params)}` : ''}`;
